import { useEffect, useRef, useCallback, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import axios from "axios";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Problem from "@/components/Problem";
import Solution from "@/components/Solution";
import Marquee from "@/components/Marquee";
import HowItWorks from "@/components/HowItWorks";
import Services from "@/components/Services";
import Future from "@/components/Future";
import EarlyAccess from "@/components/EarlyAccess";
import Footer from "@/components/Footer";
import PilotEnquiryModal from "@/components/PilotEnquiryModal";
import Admin from "@/pages/Admin";
import { Privacy, Terms } from "@/pages/Legal";
import { API } from "@/constants";

const Landing = () => {
    const earlyAccessRef = useRef(null);
    const [pilotOpen, setPilotOpen] = useState(false);
    const openPilot = useCallback(() => setPilotOpen(true), []);

    const scrollToForm = useCallback(() => {
        earlyAccessRef.current?.scrollIntoView({ behavior: "smooth" });
    }, []);

    useEffect(() => {
        axios.post(`${API}/analytics/visit`).catch(() => {});
    }, []);

    return (
        <>
            <Nav onEarlyAccess={scrollToForm} onRequestService={openPilot} />
            <main>
                <Hero onBookNow={openPilot} />
                <Problem />
                <Solution />
                <Marquee />
                <HowItWorks />
                <Services onRequestService={openPilot} />
                <Future />
                <EarlyAccess ref={earlyAccessRef} />
            </main>
            <Footer />
            <PilotEnquiryModal open={pilotOpen} onClose={() => setPilotOpen(false)} />
        </>
    );
};

function App() {
    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        const lenis = new Lenis({ lerp: 0.1, wheelMultiplier: 1 });
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        const onAnchor = (e) => {
            const a = e.target.closest('a[href^="#"]');
            if (a) {
                const el = document.querySelector(a.getAttribute("href"));
                if (el) {
                    e.preventDefault();
                    lenis.scrollTo(el);
                }
            }
        };
        document.addEventListener("click", onAnchor);
        return () => {
            cancelAnimationFrame(raf);
            document.removeEventListener("click", onAnchor);
            lenis.destroy();
        };
    }, []);

    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/admin" element={<Admin />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="*" element={<Landing />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
